const allowedNavigationKeys = ['ArrowLeft', 'ArrowRight', 'Backspace', 'Delete'];

export const validateNumbersOnly = (e) => {
  if (/[^0-9]/.test(e.key) && allowedNavigationKeys.indexOf(e.key) === -1) {
    e.preventDefault();
  }
};

export const formatterThousand = (value) =>
   `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export const parserThousand = (value) => value!.replace(/\$\s?|(,*)/g, '');

export const onPasteNumbersOnly = (e) => {
  const clipboardData = e.clipboardData || window.Clipboard;
  const pastedData = clipboardData.getData('Text').toUpperCase();

  if (/[^0-9\-+.]/.test(pastedData)) {
    e.stopPropagation();
    e.preventDefault();
  }
};

export const validateDecimalNumber = (e) => {
  const isNonNumericChar = /[^0-9\-+.]/.test(e.key);
  const isInvalidNavigationKey = allowedNavigationKeys.indexOf(e.key) === -1;

  if (isNonNumericChar && isInvalidNavigationKey) {
    e.preventDefault();
    return;
  }

  const dotCount = (e.target.value.match(/\./g) || []).length;

  if (dotCount === 1 && isInvalidNavigationKey) {
    if (e.key === '.' || e.target.value.split('.')[1]?.length > 1) {
      e.preventDefault();
    }
  }
};
